import React, { useState, createElement } from 'react';
import PropTypes from 'prop-types';
import { ViewportAction } from '@sparefoot/react-core';

let firstSpaPage = true;

export default function LazyHydrate({ children, id, noLazy }) {
	const [readyForHydration, setReadyForHydration] = useState(false);
	const isBrowser = typeof window !== 'undefined';
	const ssrElement = isBrowser && document.getElementById(id);
	const shouldHydrate = !ssrElement || readyForHydration || !firstSpaPage || noLazy;
	const divProps = { id };

	// Render normally if SSR, ready for hydration, is SPA page transition, or opted out of lazy loading
	if (shouldHydrate) {
		firstSpaPage = false;
	} else {
		divProps.dangerouslySetInnerHTML = {
			__html: ssrElement.innerHTML
		};
	}

	return (
		<ViewportAction
			onVisible={() => { setReadyForHydration(true); }}
			percentVisible={1}
			delay={0}
		>
			{createElement('div', divProps, shouldHydrate ? children : undefined)}
		</ViewportAction>
	);
}

LazyHydrate.propTypes = {
	children: PropTypes.node,
	id: PropTypes.string,
	noLazy: PropTypes.bool
};
